import html2canvas from 'html2canvas'

const VueHtml2Canvas = {
  async install(Vue, options) {
    Vue.prototype.$html2canvas = html2canvas
  },
}

export default VueHtml2Canvas
